import { credentialsSections } from "@/config/credentials";
import { useI18n } from "@/i18n";
import { getMarketingCopy } from "@/i18n/marketing-copy";

export function AboutCredentials() {
  const { locale } = useI18n();
  const localized = getMarketingCopy(locale)?.about.credentials;
  const copy = localized ?? credentialsSections;
  const sections = localized
    ? localized.sections
    : [
        credentialsSections.licensing,
        credentialsSections.insurance,
        credentialsSections.certifications,
      ];

  return (
    <section id="credentials" className="section-y">
      <div className="container-page">
        <p className="eyebrow">{copy.eyebrow}</p>
        <h2 className="display-2 mt-3 max-w-3xl text-balance">{copy.title}</h2>
        <p className="mt-4 max-w-3xl text-[1.02rem] leading-relaxed text-muted-foreground">
          {copy.body}
        </p>

        <div className="mt-12 grid gap-8 lg:grid-cols-3">
          {sections.map((section) => (
            <article key={section.title} className="rounded-xl border border-border bg-card p-8">
              <h3 className="text-xl font-semibold">{section.title}</h3>
              <ul className="mt-5 space-y-4 text-sm leading-7 text-muted-foreground">
                {section.items.map((item) => (
                  <li
                    key={item}
                    className="border-t border-border pt-4 first:border-t-0 first:pt-0"
                  >
                    {item}
                  </li>
                ))}
              </ul>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
